import api from './api'
import { AlteracaoGestao } from '@/types/campanha'
import {
  RankingAdmin,
  RankingAdminFiltro,
  RankingConfiguracao,
  RankingConfiguracaoRequest,
} from '@/types/ranking'

/** `RankingController` (AN-8 §5, DEV-O); o ranking-próprio do consultor segue no dashboard. */
const BASE_URL = '/api/v1/dashboard/ranking'

export const rankingService = {
  /** Back-office (OPERADOR+). Escopo de consultor → 403 `RANKING_SO_BACKOFFICE`. */
  configuracao: async (): Promise<RankingConfiguracao> => {
    return api.get<RankingConfiguracao>(`${BASE_URL}/configuracao`)
  },

  /** ADMIN. CAMPANHA exige `campanhaId` (não ENCERRADA); vai para a trilha (RANKING_ESCOPO). */
  salvarConfiguracao: async (req: RankingConfiguracaoRequest): Promise<RankingConfiguracao> => {
    return api.put<RankingConfiguracao>(`${BASE_URL}/configuracao`, req)
  },

  /** ADMIN: trilha das trocas de escopo (tipo RANKING_ESCOPO; valor "GERAL" ou "CAMPANHA:<uuid>"). */
  alteracoes: async (): Promise<AlteracaoGestao[]> => {
    return api.get<AlteracaoGestao[]>(`${BASE_URL}/configuracao/alteracoes`)
  },

  /** Visão ampliada: ADMIN qualquer escopo; GERENTE+GESTOR qualquer escopo, só linhas da equipe. */
  listar: async (f: RankingAdminFiltro): Promise<RankingAdmin> => {
    const params = new URLSearchParams({ periodo: f.periodo })
    const opcionais: Array<[string, string | number | undefined]> = [
      ['referencia', f.referencia],
      ['escopo', f.escopo],
      ['canal', f.canal],
      ['tenantId', f.tenantId],
      ['equipeId', f.equipeId],
      ['campanhaId', f.campanhaId],
      ['page', f.page],
      ['size', f.size],
    ]
    opcionais.forEach(([k, v]) => {
      if (v !== undefined && v !== '') params.append(k, String(v))
    })
    return api.get<RankingAdmin>(`${BASE_URL}?${params.toString()}`)
  },
}

export default rankingService
